import { graphql } from 'react-relay';

export const privacyPolicyChangeNoticeQuery = graphql`
    query privacyPolicyChangeNoticeQuery($userId: String!) {
        viewer {
            doNotShowPrivacyPolicyAlerts: isEnabled(key: "doNotShowPrivacyPolicyAlerts")
            user(userId: $userId) {
                createdDate
            }
            regionalInfo {
                countryCode
            }
        }
    }
`;
